<div class="p-3">


  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-4 my-1">
      <div *ngIf="listModelsMail != null && listModelsMail.length > 0">
        <div class="row justify-content-center">
          <label class="mt-1 mr-2">{{'Editinganexistingtemplate_EL'|trad}}</label>
          <div class="form-group-sm group-top-margin w-50" #selectModel>
            <select class="w-100 input q-main-select q-light-main-focus" (change)="loadModelMailEL($event.target.value)">
              <option value="">-------------</option>
              <option *ngFor="let model of listModelsMail" value="{{model.CodeModel}}" [selected]="model.CodeModel == selectedModelMail.CodeModel">{{model.InfoModel}}</option>
            </select>
          </div>
        </div>
      </div>

    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-3 my-1 text-center">
      <button type="button" class="btn q-btn-chap" title="{{'Createanewtemplate_EL'|trad}}" (click)="showNewModel()">
        <i class="fas fa-plus q-icon-play-chap"></i> {{'Createanewtemplate_EL'|trad}}
      </button>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-4 my-1">
      <div class="row justify-content-center">
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 text-center">
          <div *ngIf="showmodel">
            <button type="button" class="btn btn-save" (click)="saveModelMail()"><i class="fas fa-save"></i><span> {{'Save_EL'|trad}}</span></button>
          </div>
        </div>
        <div class="col-6 col-sm-6 col-md-6 col-lg-6 text-center">
          <div *ngIf="showmodel && selectedModelMail && selectedModelMail.Ident && selectedModelMail.Ident.length > 0">
            <button type="button" class="btn btn-remove" data-toggle="modal" data-target="#ModalDelete"><i class="fas fa-trash-alt"></i><span> {{'DeleteEL'|trad}}</span></button>
          </div>
        </div>
        <br />
      </div>
    </div>
  </div>

  <div class="row" *ngIf="showmodel">
    <div class="col-12 col-sm-12 col-md-12 col-lg-8 mt-3">
      <div class="row text-center" *ngIf="showErrMod">
        <div class="col-0 col-sm-0 col-md-2 col-lg-2"></div>
        <div class="alert alert-danger col-12 col-sm-12 col-md-8 col-lg-8" role="alert">
          <div class="row">
            <div class="col-1 col-sm-1 col-md-1 col-lg-1"></div>
            <div class="col-9 col-sm-9 col-md-9 col-lg-9 text-center">
              <p>
                {{'Unsavedmailtemplate_EL'|trad}} : {{'Pleasefillintherequiredfields_EL'|trad}} <span class="q-span-required">*</span>
              </p>
            </div>
            <div class="col-2 col-sm-2 col-md-2 col-lg-2 text-right">
              <i class="fas fa-times ispointer" aria-hidden="true" (click)="displayErrMod()"></i>
            </div>
          </div>
        </div>
        <div class="col-0 col-sm-0 col-md-2 col-lg-2"></div>
      </div>

      <div class="form-group row">
        <label class="col-3 col-sm-2 col-md-2 col-lg-2 text-right">{{'Name_EL'|trad}} <span class="q-span-required" *ngIf="showErrMod && !selectedModelMail.InfoModel">*</span></label>
        <div class="col-9 col-sm-5 col-md-5 col-lg-5">
          <input class="form-control q-input-required" [(ngModel)]="selectedModelMail.InfoModel" placeholder="{{'Templatename_EL'|trad}}">
        </div>
        <div class="col-12 col-sm-12 col-md-5 col-lg-5">
          <div class="form-group row mb-0">
            <label class="col-6 col-sm-6 col-md-6 col-lg-6 text-right">{{'Defaulttemplate_EL'|trad}} ?</label>
            <div class="col-1 col-sm-1 col-md-1 col-lg-1">
              <input [(ngModel)]="selectedModelMail.IsDefault" type="checkbox">
            </div>
          </div>
        </div>


      </div>


      <div class="form-group row">
        <label class="col-3 col-sm-2 col-md-2 col-lg-2 text-right">{{'From_EL'|trad}} : <span class="q-span-required" *ngIf="showErrMod && !selectedModelMail.SenderMail">*</span></label>
        <div class="col-9 col-sm-5 col-md-5 col-lg-5">
          <input class="form-control" [(ngModel)]="selectedModelMail.SenderMail" placeholder="{{'Sendersmail_EL'|trad}}">
        </div>
        <div class="col-0 col-sm-5 col-md-5 col-lg-5"></div>
      </div>
      <div class="form-group row">
        <label class="col-3 col-sm-2 col-md-2 col-lg-2 text-right">{{'CC_EL'|trad}} : </label>
        <div class="col-9 col-sm-5 col-md-5 col-lg-5">
          <q-inputmail-list style="flex: 1;" class="form-control" [(list)]="selectedModelMail.CC" placeholder="{{'Mailcc_EL'|trad}}" ></q-inputmail-list>
        </div>
        <div class="col-0 col-sm-5 col-md-5 col-lg-5"></div>
      </div>
      <div class="form-group row">
        <label class="col-3 col-sm-2 col-md-2 col-lg-2 text-right">{{'CCI_EL'|trad}} : </label>
        <div class="col-9 col-sm-5 col-md-5 col-lg-5">
          <q-inputmail-list style="flex: 1;" class="form-control" [(list)]="selectedModelMail.CCI" placeholder="{{'Mailcci_EL'|trad}}" ></q-inputmail-list>
        </div>
        <div class="col-0 col-sm-5 col-md-5 col-lg-5"></div>
      </div>
      <div class="form-group row">
        <label class="col-3 col-sm-2 col-md-2 col-lg-2 text-right">Objet : </label>
        <div class="col-9 col-sm-9 col-md-9 col-lg-9">
          <input class="form-control" [(ngModel)]="selectedModelMail.Object" placeholder="Objet du mail">
        </div>
        <div class="col-0 col-sm-1 col-md-1 col-lg-1"></div>
      </div>
      <p class="q-police"><strong>{{'Writingtheemailtemplate_EL'|trad}}</strong></p>
      <ckeditor [editor]="Editor"
                [config]="
                  {
                  toolbar: {
                  items: ['undo','redo','|','outdent','indent','|','findAndReplace','sourceEditing','|','bold','italic','underline','strikethrough','removeFormat','pageBreak','|','fontColor','fontBackgroundColor','fontFamily','fontSize',
                  'alignment','highlight','|','link','imageInsert','mediaEmbed','htmlEmbed','|','bulletedList','numberedList','todoList','insertTable','|','heading','blockQuote','horizontalLine','|','code','codeBlock','|','specialCharacters',
                  'subscript','superscript', 'exportPdf', 'exportWord'],
                  shouldNotGroupWhenFull: true
                  },
                  image: {toolbar: [ 'imageStyle:full', 'imageStyle:side', '|', 'imageTextAlternative' ]},
                  fontSize: {options: ['default', 8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 22, 24, 26, 28, 36, 48, 50]},
                  link: { addTargetToExternalLinks: true },
                  table: { contentToolbar: [ 'tableRow', 'tableColumn', 'mergeTableCells', 'tableCellProperties', 'tableProperties' ] },
                  removePlugins: ['Title']
                  }"
                [(ngModel)]="selectedModelMail.ContentMail"
                skin="moono-lisa" lang="fr" fullPage="true" ngDefaultControl></ckeditor>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-4">
      <div class="q-bloc-fixed">
        <div class="tabs">
          <ng-container *ngFor="let tab of tabs">
            <button *ngIf="tab.Visible" class="q-btn tab-button" [ngClass]="{'tab-select': tab.Active}" (click)="ActiveTab(tab.Type)" [disabled]="tab.Locked"><i [ngClass]="tab.Font"></i><strong>{{tab.Name}}</strong></button>
          </ng-container>
        </div>

        <div *ngIf="tabs[0].Visible" [ngClass]="{'d-none': !tabs[0].Active }" class="q-block-property pr-3">
          <div>
            <div class="row justify-content-center">
              <div class="col-1 col-sm-1 col-md-1 col-lg-1"></div>
              <div class="col-10 col-sm-10 col-md-10 col-lg-10">
                <input id="copy" class="form-control text-center" [(ngModel)]="propertyToCopy" [disabled]="!propertyToCopy || propertyToCopy.length === 0" placeholder="Choisir une propriété à copier">
              </div>
              <div class="col-1 col-sm-1 col-md-1 col-lg-1"></div>
            </div>
          </div>
          <br />
          <div class="row m-0 q-shadow">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 p-0">
              <table class="table-condensed table-bordered">
                <thead>
                  <tr>
                    <th class="text-center q-table-title">{{'Object_EL'|trad}}</th>
                    <th class="text-center q-table-title">{{'Property_EL'|trad}}</th>
                    <th class="text-center q-table-title">{{'Format_EL'|trad}}</th>
                    <th class="text-center q-table-title">{{'Copytheproperty_EL'|trad}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let bo of listBoObject; let i = index" class="q-table-item">
                    <td class="text-center">
                      {{bo.Name}}
                    </td>
                    <td class="text-center">
                      <select class="w-100 input q-main-select q-light-main-focus" (change)="selectProp(bo, $event.target.value)">
                        <option [value]="-1">[{{'Choosetheproperty_EL'|trad}}]</option>
                        <option *ngFor="let prop of bo.ListProperties; let j = index" [value]="j">{{prop.Name}}</option>
                      </select>
                    </td>
                    <td class="text-center" >
                      <select class="w-100 input q-main-select q-light-main-focus" (change)="selectFormat(bo, $event.target.value)">
                        <option [value]="-1">[{{'Noformat_EL'|trad}}]</option>                        
                        <ng-container *ngIf="bo.PropSelected && bo.PropSelected?.ListFormatOption?.length > 0">
                          <option *ngFor="let format of bo.PropSelected?.ListFormatOption; let j = index" [value]="j">{{format.Text}}</option>
                        </ng-container>
                      </select>
                    </td>
                    <td class="text-center">
                      <div *ngIf="bo.HasPropSelected">
                        <button (click)="createUnionField(bo)"><i class="far fa-copy"></i></button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
        <div *ngIf="tabs[1].Visible" [ngClass]="{'d-none': !tabs[1].Active }" class="q-block-property q-shadow">
          <div class="row m-0 q-shadow">
            <q-insert-image class="w-100" [CanDelete]="false"></q-insert-image>

          </div>

        </div>
      </div>

    </div>
  </div>

</div>

<div class="modal fade" id="ModalDelete" tabindex="-1" role="dialog" aria-labelledby="ModalDelete" aria-hidden="true" #modalDeleteTemplate>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title ml-3"> {{'Deleteamailtemplate_EL'|trad}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModalDelete()" #closeDelete>
          <span aria-hidden="true">+</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container">
          <div class="row justify-content-center">
            <strong class="q-police">{{'Doyouwantdeletemailtemplate_EL'|trad}} {{modelName}} ?</strong>
          </div>
          <br />
          <div class="row justify-content-center">
            <button type="button" class="btn btn-outline-danger" (click)="confirmDelete()"><i class="fas fa-check"></i></button>
          </div>
          <br />
          <div class="row text-center" *ngIf="showErrDelete">
            <br />
            <div class="col-0 col-sm-0 col-md-2 col-lg-2"></div>
            <div class="alert alert-danger col-12 col-sm-12 col-md-8 col-lg-8" role="alert">
              <div class="row justify-content-center">
                <p>
                  {{'DeleteTemplateNotPossible1_EL'|trad}}. {{'DeleteTemplateNotPossible2_EL'|trad}}
                </p>
              </div>
            </div>
            <div class="col-0 col-sm-0 col-md-2 col-lg-2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



